import React from 'react';
import styled from 'styled-components';

export interface BannerSubtitleProps {
  subtitle: string;
  className?: string;
}

const SubtitleContainer = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: center;
  font-size: 16px;
  color: #414042;
  font-family: Lato;
`;

const SubtitleText = styled.b`
  flex: 1;
  position: relative;
`;

const BannerSubtitle: React.FC<BannerSubtitleProps> = ({
  subtitle,
  className,
}) => {
  return (
    <SubtitleContainer className={className}>
      <SubtitleText>{subtitle}</SubtitleText>
    </SubtitleContainer>
  );
};

export default BannerSubtitle;
